import React from 'react';

interface Props {
  children?: React.ReactNode | string;
}

function XThead(props: Props) {
  const { children } = props;
  return (
    <>
      <thead
        style={{
          backgroundColor: '#f6f8fb',
          color: '#223354',
        }}
      >
        {children}
      </thead>
    </>
  );
}

export default XThead;
